define('catalogsDetailView',[
  'app',
  'module',
  'underscore',
  'windows',
  'headerFooterView',
  'catalogsDetailTabsView'
], function (
  App,
  Module,
  _,
  Windows,
  HeaderFooterView,
  TabsView
) {
  'use strict';

  Module.exports = HeaderFooterView.extend({
    className: 'catalogs-detail-view ' + HeaderFooterView.prototype.className,
    // Use a tabs child view to render Details and Templates
    childView: TabsView,
    childViewOptions: function () {
      return {
        model: this.model,
        catalogSecId: this.options.catalogSecId
      };
    },

    initialize: function(){
      HeaderFooterView.prototype.initialize.call(this);
      // Update window title when name changes
      if (this.model) {
        this.listenTo(this.model, 'change:name', _.bind(function(){
          if (this.windowView && _.isFunction(this.windowView.setTitle)) {
            this.windowView.setTitle();
          }
        }, this));
      }
    },

    // Static open method like other detail views
    open: function (secId) {
      require([
        'windows',
        'catalogsDetailView',
        'catalogEntities'
      ], _.bind(function (Windows, View) {
        Windows.open({
          view: function(){
            var defer = $.Deferred();
            // We do not have a specific GET detail endpoint; reuse list and pick
            App.request('catalogs:list').done(function(items){
              var model = _.find(items, function(m){ return m.get('secId') === secId; }) || App.request('catalog:model', {secId: secId});
              // Pass catalogSecId so the child view (Templates list) can build its URLs
              defer.resolve(new View({ model: model, catalogSecId: secId }));
            });
            return defer.promise();
          },
          id: 'catalog:' + secId,
          title: function(windowView, view){
            return (_.i18n('catalogs.detail.title') || 'Catalog') + ' | ' + (view.model.getName ? view.model.getName() : view.model.get('secId'));
          },
          width: '80%',
          height: '80%'
        });
      }, this));
    }
  });
});

